<template>
  <v-popover
    :offset="offset"
    popover-class="popover__header"
    placement="top"
    :open-group="openGroup"
    class="ml-1"
  >
    <icon
      :icon="type"
      :class="`tooltip-target ${type}-icon`"
    />

    <template slot="popover">
      <slot />
    </template>
  </v-popover>
</template>

<script>
export default {
  props: {
    offset: {type: Number, default: 4},
    type: {type: String, default: 'help'},
    openGroup: {type: String, default: 'title'},
  },
}
</script>

<style lang="scss">
  .v-popover  {
    display: inline-block;
    .tooltip-target.help-icon {
      cursor: pointer;
      fill: #c2c7d9;
    }
    &.open {
      .tooltip-target.help-icon {
         fill: #262e47;
      }
    }
  }
</style>
